import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";

export class BidInsulatedPipesBus extends BaseBus{
    constructor(busObj: BidInsulatedPipesBus) {
        super(busObj);

    }
    CID(): any {
        return this.bidInsulationId ;
    }
    setId(id: any) {
        this.bidInsulationId  = id;
    }
    initialize(data: BidInsulatedPipesBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setParentId(id: any) {
       //this.bidSheetDetailId = id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: BidInsulatedPipesBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }

    bidInsulationId : string;
   bidSheetDetailId:string;
   bidPipeSizeId:string;
    thicknessId : number;
    lf:string;
    cost : number;
    fgPart : number;
    insertDt : Date;
    insertUserId : string;
    updateDt : Date;
    updateUserId :string;
    pipeTypeValue:string;
    thickValue:number;
    pipeSizeValue:number;
    thickDescr:string;

}